/* DP email popup: 10% off the first order for joining the list.
   v17: never opens over the scroll film or the cart toast. */
(function () {
  'use strict';
  var pop = document.getElementById('dpop');
  if (!pop) return;
  var card = pop.querySelector('.dpop-card');
  var join = pop.querySelector('[data-dpop-join]');
  var done = pop.querySelector('[data-dpop-done]');
  var KEY = 'dp_pop', DAYS = 14;
  function load() { try { return JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { window.localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  var state = load();
  var open = false, from = null;

  function focusables() {
    return [].slice.call(card.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled])'))
      .filter(function (n) { return n.offsetParent !== null; });
  }
  function onKey(e) {
    if (e.key === 'Escape') { hide(true); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1], cur = document.activeElement;
    if (cur === card || !card.contains(cur)) { e.preventDefault(); (e.shiftKey ? z : a).focus(); }
    else if (e.shiftKey && cur === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && cur === z) { e.preventDefault(); a.focus(); }
  }
  /* focus goes to the dialog itself, not the email box: no phone keyboard popping up, and the
     form's spam check only loads once someone actually starts typing */
  function show(focusEl) {
    if (open) return;
    open = true;
    from = document.activeElement;
    pop.hidden = false;
    document.documentElement.classList.add('dpop-lock');
    document.body.classList.add('dpop-open');
    card.setAttribute('aria-labelledby', done && !done.hidden ? 'dpop-h2' : 'dpop-h');
    var first = focusEl || ((done && !done.hidden) ? done.querySelector('.dpop-copy') : null);
    setTimeout(function () { (first || card).focus({ preventScroll: true }); }, 40);
    document.addEventListener('keydown', onKey);
  }
  function hide(remember) {
    if (!open) return;
    open = false;
    pop.hidden = true;
    document.documentElement.classList.remove('dpop-lock');
    document.body.classList.remove('dpop-open');
    document.removeEventListener('keydown', onKey);
    if (remember && !(state && state.s === 'joined')) save({ s: 'closed', t: Date.now() });
    if (from && from.focus) from.focus({ preventScroll: true });
  }
  pop.addEventListener('click', function (e) { if (e.target.closest('[data-dpop-close]')) hide(true); });

  var copy = pop.querySelector('[data-dpop-copy]');
  if (copy) copy.addEventListener('click', function () {
    var code = copy.getAttribute('data-dpop-copy');
    var ok = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 2200); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(ok, ok);
    else {
      var r = document.createRange(), c = pop.querySelector('.dpop-code code');
      r.selectNodeContents(c); var s = getSelection(); s.removeAllRanges(); s.addRange(r); ok();
    }
  });

  var form = pop.querySelector('form');
  if (form) form.addEventListener('submit', function () { save({ s: 'joined', t: Date.now() }); });

  /* back from a signup (this form or the footer form): show the code */
  if (/[?&]customer_posted=true/.test(location.search)) {
    state = { s: 'joined', t: Date.now() };
    save(state);
    if (join) join.hidden = true;
    if (done) done.hidden = false;
    show();
    return;
  }
  /* the signup had a problem (for example a mistyped email): reopen with the message */
  if (pop.querySelector('[data-dpop-error]')) { show(pop.querySelector('input[type=email]')); return; }
  if (state && (state.s === 'joined' || (state.s === 'closed' && Date.now() - state.t < DAYS * 864e5))) return;

  /* never cover the scroll film while it is on screen */
  function inFilm() {
    var h = document.querySelector('.hero:not(.static)');
    if (!h) return false;
    var r = h.getBoundingClientRect();
    return r.top < innerHeight * 0.5 && r.bottom > innerHeight * 0.5;
  }
  var fired = false;
  function fire() {
    if (fired) return;
    fired = true;
    removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onOut);
    if (inFilm() || document.querySelector('.added:not([hidden]), dialog[open], .dpp-toast.on')) { setTimeout(function () { fired = false; fire(); }, 5000); return; }
    show();
  }
  function onScroll() {
    var h = document.documentElement.scrollHeight - innerHeight;
    if (h > 400 && scrollY / h > 0.5) fire();
  }
  function onOut(e) { if (!e.relatedTarget && e.clientY < 10) fire(); }
  /* the 15-second clock starts with the first sign of a real visitor (scroll, tap, key or mouse), never on an untouched page */
  var armed = false;
  function arm() { if (armed) return; armed = true; setTimeout(fire, 15000); }
  ['scroll', 'pointerdown', 'keydown', 'mousemove', 'touchstart'].forEach(function (t) { addEventListener(t, arm, { passive: true, once: true }); });
  addEventListener('scroll', onScroll, { passive: true });
  if (window.matchMedia && matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', onOut);
})();
